import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmDialog = ({ showDialog, message, onConfirm, onClose }) => {
  if (!showDialog) {
    return null;
  }

  const handleConfirm = async () => {
    try {
      await onConfirm(); // Await the promise
      onClose(); // Close dialog after confirmation
    } catch (error) {
      console.error("Error in confirm action:", error);
      // Optionally show error in Snackbar (requires context access)
    }
  };

  return (
    <Dialog open={showDialog} onClose={onClose}>
      <DialogTitle>Confirmação</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;